import { j as t } from "../../../../../node_modules/react/jsx-runtime.js";
import { memo as s } from "react";
import l from "../../../Pagination/Pagination.js";
import { Typography as o } from "../../../../atoms/Typography/Typography.js";
import { clsx as x } from "../../../../../node_modules/clsx/dist/clsx.m.js";
import { i18n as i } from "../../../../../utils/locale/locale.js";
const f = ({
  fetched: a,
  hidePagination: n = !1,
  ...e
}) => {
  const r = Number(a) > 0 && Number(e == null ? void 0 : e.total_entries) > 0;
  return /* @__PURE__ */ t.jsxs(
    "div",
    {
      className: x(
        `flex  ${r ? "justify-between" : "justify-end"} items-center flex-wrap w-full`
      ),
      "data-testid": "table-pagination-container",
      children: [
        r && /* @__PURE__ */ t.jsxs("div", { className: "flex items-center gap-050 text-nowrap p-[10px] pt-[22px]", children: [
          /* @__PURE__ */ t.jsx(
            o,
            {
              text: i("results_found"),
              variant: "interface/default/s",
              textColor: "color/fg/lightest"
            }
          ),
          /* @__PURE__ */ t.jsx(
            o,
            {
              text: a,
              variant: "interface/strong/s",
              textColor: "color/fg/bold"
            }
          ),
          /* @__PURE__ */ t.jsx(
            o,
            {
              text: i("of"),
              variant: "interface/default/s",
              textColor: "color/fg/lightest"
            }
          ),
          /* @__PURE__ */ t.jsx(
            o,
            {
              text: e.total_entries,
              variant: "interface/strong/s",
              textColor: "color/fg/bold"
            }
          )
        ] }),
        !n && /* @__PURE__ */ t.jsx(l, { ...e })
      ]
    }
  );
}, j = s(f);
export {
  j as default
};
//# sourceMappingURL=TablePagination.js.map
